'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('calendar', {
      url: '/calendar',
      template: '<calendar></calendar>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/calendar/calendar.routes.js